import React, { PureComponent, Fragment } from 'react';
import ComplianceActivity from '../../ComplianceActivity'
import moment from 'moment'
import Linkify from 'react-linkify'

const Ava1 = process.env.PUBLIC_URL + '/img/profile-1.png';


class ComplianceLog extends PureComponent {

    renderMessage = (activity) => {
        return activity.comment ?
            <Linkify properties={{ target: '_blank' }}>
                {activity.comment.split('\n').map((item, key) => {
                    return <Fragment key={key}>{item}<br /></Fragment>
                })}
            </Linkify> :
            activity.fileName ? <p>New File Upload: <a href={activity.filePath}>{`${activity.fileName}`}</a></p > : null
    }

    renderActivities = () => {
        const activities = this.props.notes.slice(0)
        activities.sort((a, b) => moment(a.createdAt).diff(moment(b.createdAt)))

        let regEx = new RegExp("([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?"); // eslint-disable-line max-len
        return activities.reverse().map((activity, i) => {
            let link
            if (regEx.test(activity.comment)) {
                link = 'url-container'
            }
            else {
                link = null
            }
            return <div key={i} className={`${link} comment`} style={{

            }}>
                <ComplianceActivity
                    type={link}
                    key={i}
                    img={Ava1}
                    date={moment(activity.createdAt).fromNow()}
                    name={`${activity.createdBy}`}>
                    {this.renderMessage(activity)}
                </ComplianceActivity>
            </div>
        })
    }
    render () {
        return (
            <div>
                {this.renderActivities()}
            </div>
        )
    }
}

export default ComplianceLog


// WEBPACK FOOTER //
// ./src/components/compliance/components/ComplianceLog.js